var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9126 3.08751C11.1404 3.31532 11.1404 3.68466 10.9126 3.91247L3.91256 10.9125C3.68475 11.1403 3.31541 11.1403 3.0876 10.9125C2.8598 10.6847 2.8598 10.3153 3.0876 10.0875L10.0876 3.08751C10.3154 2.85971 10.6848 2.85971 10.9126 3.08751Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0876 3.08751C3.31541 2.85971 3.68475 2.85971 3.91256 3.08751L10.9126 10.0875C11.1404 10.3153 11.1404 10.6847 10.9126 10.9125C10.6848 11.1403 10.3154 11.1403 10.0876 10.9125L3.0876 3.91247C2.8598 3.68466 2.8598 3.31532 3.0876 3.08751Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.108ccecfb2f0f49e265669fbfdacdf2a.svg";
export { ForwardRef as ReactComponent };